import React from "react";

export const KnightGamesCTA = () => {
	return (
		<div className="cta">
			<h2>Wishlist Knight Games on Steam!</h2>
			<iframe
				className="steam-embed"
				title="Wishlist Knight Games on Steam!"
				src="https://store.steampowered.com/widget/3752150/"
			></iframe>
			<a className="mobile-cta button" href="https://store.steampowered.com/app/3752150/Knight_Games/" target="_blank" rel="noreferrer">
				Wishlist on Steam <i className="fas fa-external-link-alt" />
			</a>
		</div>
	);
};
